import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FiCamera, FiEdit3, FiBox } from 'react-icons/fi'

export default function Home() {
  const { t } = useTranslation()

  const features = [
    {
      icon: FiCamera,
      title: '图片转3D',
      description: '上传任意图片，AI自动生成高质量3D模型',
    },
    {
      icon: FiEdit3,
      title: '文字转3D',
      description: '输入描述文字，AI根据描述生成3D模型',
    },
    {
      icon: FiBox,
      title: '多角度生成',
      description: '支持多张图片输入，生成更精确的3D模型',
    },
  ]

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-luxury-navy-950 via-luxury-navy-900 to-luxury-navy-950" />
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-luxury-gold-500/20 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-copper/20 rounded-full blur-3xl" />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6">
              <span className="gradient-text">{t('home.title')}</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">{t('home.subtitle')}</p>
            <Link
              to="/create"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-luxury-gold-600 to-luxury-gold-500 text-luxury-navy-950 font-semibold rounded-lg hover:from-luxury-gold-500 hover:to-luxury-gold-400 transition-colors text-lg"
            >
              {t('home.cta')}
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-luxury-navy-900/50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-luxury-navy-900/50 backdrop-blur-sm rounded-xl border border-luxury-gold-800/30 p-8 hover:border-luxury-gold-500/50 transition-colors"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-luxury-gold-600 to-copper rounded-lg flex items-center justify-center mb-6">
                  <feature.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="bg-gradient-to-r from-luxury-gold-600/20 to-copper/20 rounded-2xl border border-luxury-gold-800/30 p-12 text-center">
            <h2 className="text-3xl font-serif font-bold text-white mb-4">
              准备好创建您的3D模型了吗？
            </h2>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              无需登录即可上传图片并生成3D模型。登录后可保存模型到您的账户并上架到NFT市场。
            </p>
            <Link
              to="/create"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-luxury-gold-600 to-luxury-gold-500 text-luxury-navy-950 font-semibold rounded-lg hover:from-luxury-gold-500 hover:to-luxury-gold-400 transition-colors"
            >
              开始创建
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
